import { useCallback } from 'react';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import { addConfigurationItems } from '../../../reducers/documentation/documentationReducer';
import { ConfigurationType } from '@server/parser';
import { telemetry } from '../../../telemetry';
import { useDispatch } from 'react-redux';

export const useLayouts = () => {
  const dispatch = useDispatch();
  const { get_layout } = useDocumentationApiFacade();

  const fetchLayoutData = useCallback(
    async (metadataId: string, crmOrgId: string) => {
      try {
        const response = await get_layout(metadataId);
        dispatch(
          addConfigurationItems({
            crmOrgId,
            newConfigurationItems: { [ConfigurationType.layouts]: [response] },
          }),
        );
        return response;
      } catch (error) {
        telemetry.captureError(`Error during layout fetch for metadataId ${metadataId}`, error);
      }
    },
    [get_layout, dispatch],
  );

  return { fetchLayoutData };
};
